export default "__VITE_ASSET__vxLXtpR6__"